// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Report .MuiTableCell-root {\r\n  border: 1px solid rgba(224, 224, 224, 1);\r\n  font-size: 1.25rem;\r\n}", "",{"version":3,"sources":["webpack://src/module/report/table.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,kBAAkB;AACpB","sourcesContent":[".Report .MuiTableCell-root {\r\n  border: 1px solid rgba(224, 224, 224, 1);\r\n  font-size: 1.25rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
